export enum SidebarStatus {
  HIDDEN = 'sidebar-hidden',
  COLLAPSED = 'sidebar-collapsed',
  EXPANDED = 'sidebar-expanded',
}

export const LOCAL_STORAGE_KEY_SIDEBAR_STATUS = 'sidebar-status'
export const DEFAULT_SIDEBAR_STATUS = SidebarStatus.COLLAPSED
export const SIDEBAR_WIDTH_COLLAPSED = 65
export const SIDEBAR_WIDTH_EXPANDED = 240
